// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EditUserEmail_wrapper__2LLwj","buttonsWrapper":"EditUserEmail_buttonsWrapper__Ov2aH","addNewEmailButton":"EditUserEmail_addNewEmailButton__2vZ8M"};